import {
  Header,
  ParcelSearchFilterWrapper,
  setDateFromStorage,
  useTranslation
} from '@fareye/common'
import { IDateRange } from '@fareye/types'
import { DatePicker, Flex, SearchSelect, Span } from '@fareye/ui'
import {
  dMmm,
  getQueryParams,
  getSearchFilterFromSession,
  isEmpty,
  yyyyMmDd,
  MdFilterList
} from '@fareye/utils'
import queryString, { ParsedQuery } from 'query-string'
import React from 'react'
import { mapping } from '../../../config/mapComponents'
import { PARCEL_TYPES, SHIPMENT_TYPES } from '../../../config/constants'
import SummaryFilter from '../../../components/SummaryV2'
import { SummarFilterWrapper, MoreFilterButton } from '../../../style/styled'
import {
  ISelectedSummaryFilter,
  ISelectedMoreFilter
} from '../../../utility/types'
import { AddFiltersListing } from '../../../components/MoreFilters/AddFiltersListing'
import FoundList from '../components/FoundList'
import { inTransitConstant } from '../../../config/constants'

export default function ParcelListing({
  match,
  config,
  history,
  location,
  routesConfig
}: any) {
  const searchParams: ParsedQuery<string | Date> = queryString.parse(
    location.search
  )
  const {
    links,
    carryDate,
    showDatePicker,
    showSummary = true,
    showMoreFilters = true,
    showTimezone,
    toggleContent,
    showParcelTypeFilter = false
  } = config.config
  const { children, styling, globalSearchPageId, filters } = config
  const { style, className, bodyBgColor, variant, layoutStyle } = styling
  const [globalSearch, setGlobalSearch] = React.useState(
    getSearchFilterFromSession(globalSearchPageId)
  )
  const inititalSelectedSummaryFilter = {
    selectedFilters: {},
    numberOfFiltersApplied: 0
  }
  const [selectedSummaryFilter, setSelectedSummaryFilter] = React.useState<
    ISelectedSummaryFilter
  >(inititalSelectedSummaryFilter)
  const [summaryData, setSummaryData] = React.useState([])
  const [showMoreFiltersModal, setShowMoreFiltersModal] = React.useState(false)
  const [selectedMoreFilter, setSelectedMoreFilter] = React.useState<
    ISelectedMoreFilter
  >({
    selectedFilters: {}
  })
  const [notFoundList, setNotFoundList] = React.useState([])
  const [foundCount, setFoundCount] = React.useState(0)

  const filterSelectedKey = toggleContent
    ? toggleContent.filter((item: any) =>
        item.link ? item.link === match.path : true
      )
    : []
  const [selectedKey, setSelectedKey] = React.useState(
    filterSelectedKey.length ? filterSelectedKey[0].selectedKey : ''
  )

  const [lastUpdate, setLastUpdate] = React.useState<string>('')
  const [dateRange, setDateRange] = React.useState(() => {
    return setDateFromStorage({
      showDatePicker: !!showDatePicker,
      carryDate,
      searchParams,
      daysDiff: 20
    })
  })
  const [selectedShipmentType, setSelectedShipmentType] = React.useState(
    PARCEL_TYPES[0]
  )
  const { startDate, endDate } = dateRange as IDateRange<Date>
  const { t } = useTranslation()
  React.useEffect(() => {
    if (showDatePicker) {
      let prevStartDate = searchParams.startDate
      let prevEndDate = searchParams.endDate
      if (prevStartDate !== startDate || prevEndDate !== endDate) {
        const queryParams = getQueryParams({
          ...queryString.parse(location.search),
          startDate,
          endDate
        })
        history.replace({
          pathname: match.url,
          search: queryParams
        })
      }
    }
  }, [dateRange])

  React.useEffect(() => {
    setNotFoundList([])
    setFoundCount(0)
  }, [globalSearch])

  function setDateRangeAndStorage(dates: IDateRange<string | Date>) {
    localStorage.setItem('date', JSON.stringify(dates))
    setDateRange(dates as IDateRange<Date>)
    setSelectedSummaryFilter(inititalSelectedSummaryFilter)
  }

  function setGlobalSearchAndSummaryFilter(ele: any) {
    setSelectedSummaryFilter(inititalSelectedSummaryFilter)
    setGlobalSearch(ele)
  }

  const fileName = (match.params && (match.params as any).id) || 'parcel'
  const { component } = config.children[selectedShipmentType.key]
  const ComponentRender = (mapping as any)[component]

  const apiFilter = React.useMemo(() => {
    let filterConfig = config?.filters?.apiFilter
    filterConfig.queryParams.dataSource = selectedShipmentType.dataSource
    return filterConfig
  }, [selectedShipmentType])
  const selectedAggsFilter = React.useMemo(() => {
    return {
      ...selectedMoreFilter.selectedFilters,
      ...selectedSummaryFilter.selectedFilters
    }
  }, [selectedMoreFilter, selectedSummaryFilter])
  return (
    <>
      <Flex column width={1} style={{ ...layoutStyle, height: '100%' }}>
        <Header
          match={match}
          toggle={toggleContent}
          lastUpdate={lastUpdate}
          selectedKey={selectedKey}
          setSelectedKey={setSelectedKey}
          startDate={startDate}
          endDate={endDate}
          location={location}
          history={history}
          routesConfig={routesConfig}
          rightTopCorner={
            <Flex>
              {showDatePicker && (
                <DatePicker
                  variant="fareyeV2"
                  formatter={yyyyMmDd}
                  onDateRangeSelected={setDateRangeAndStorage}
                  value={dateRange}
                />
              )}
            </Flex>
          }
          showTimezone={showTimezone}
        >
          <Flex column width={1}>
            <Flex>
              {showParcelTypeFilter && (
                <SearchSelect
                  options={PARCEL_TYPES || []}
                  value={selectedShipmentType}
                  placeholder={t('Select Shipment Type')}
                  onChange={(item: any) => {
                    setSelectedShipmentType(item)
                  }}
                  t={t}
                  style={{
                    container: {
                      padding: '0 8px',
                      borderRadius: '0px',
                      marginTop: '-3px'
                    },
                    wrapper: {
                      width: '17%',
                      alignItems: 'flex-start',
                      marginTop: '6px'
                    },
                    control: {
                      height: '45px'
                    },
                    dropdownIndicator: {
                      display: 'block',
                      transform: 'rotate(0deg) !important'
                    }
                  }}
                />
              )}
              <ParcelSearchFilterWrapper
                apiFilter={apiFilter}
                apiFav={config?.filters?.apiFav}
                pageId="intransit"
                search={globalSearch}
                setSearch={setGlobalSearchAndSummaryFilter}
                startDate={startDate}
                endDate={endDate}
                showTimezone={showTimezone}
                showIcon={showParcelTypeFilter}
              />
            </Flex>
            {(foundCount !== 0 || !isEmpty(notFoundList)) &&
              !isEmpty(globalSearch) && (
                <FoundList
                  notFoundList={notFoundList}
                  foundCount={foundCount}
                />
              )}
            <Flex>
              {showSummary && !isEmpty(summaryData) && (
                <SummarFilterWrapper>
                  <SummaryFilter
                    selectedSummaryFilter={selectedSummaryFilter}
                    setSelectedSummaryFilter={setSelectedSummaryFilter}
                    summaryData={Object.fromEntries(
                      Object.entries(summaryData).filter(([key]) =>
                        ['status'].includes(key)
                      )
                    )}
                  />
                </SummarFilterWrapper>
              )}
              <Flex justifyContentFlexEnd style={{ flex: '1 1 auto' }}>
                <MoreFilterButton
                  onClick={() => setShowMoreFiltersModal(true)}
                  leftChild={
                    <MdFilterList
                      style={{
                        width: '16px',
                        height: '16px',
                        left: '-1px',
                        top: '-1px',
                        color: '#1276D3'
                      }}
                    />
                  }
                >
                  <Span
                    variant="h6"
                    style={{
                      color: '#1276D3'
                    }}
                  >
                    {t(inTransitConstant['moreFilters'])}
                  </Span>
                </MoreFilterButton>
              </Flex>
            </Flex>
          </Flex>
        </Header>
        <div style={{ flexGrow: 1, background: bodyBgColor }}>
          <div
            style={{
              flexGrow: 1,
              background: bodyBgColor,
              padding: '10px 15px'
            }}
          >
            <ComponentRender
              key={selectedShipmentType.key}
              match={match}
              fileName={`${fileName}_${dMmm()}`}
              history={history}
              mapping={mapping}
              location={location}
              type={selectedShipmentType}
              selectedKey={selectedKey}
              setLastUpdate={setLastUpdate}
              setSummaryFilter={setSelectedSummaryFilter}
              setSummaryData={setSummaryData}
              summaryData={summaryData}
              setNotFoundList={setNotFoundList}
              setFoundCount={setFoundCount}
              endDate={showDatePicker ? endDate : null}
              startDate={showDatePicker ? startDate : null}
              showDatePicker={showDatePicker}
              config={config.children[selectedShipmentType.key]}
              globalSearch={globalSearch}
              selectedAggsFilter={selectedAggsFilter}
              selectedFilters={selectedMoreFilter}
              setSelectedFilters={setSelectedMoreFilter}
              showTimezone={showTimezone}
            />
          </div>
        </div>
      </Flex>
      {showMoreFilters && (
        <AddFiltersListing
          selectedMoreFilter={selectedMoreFilter}
          setSelectedMoreFilter={setSelectedMoreFilter}
          showMoreFiltersModal={showMoreFiltersModal}
          setShowMoreFiltersModal={setShowMoreFiltersModal}
          moreFilterOptions={Object.fromEntries(
            Object.entries(summaryData).filter(
              ([key]) => !['status'].includes(key)
            )
          )}
          globalSearch={globalSearch}
        />
      )}
    </>
  )
}
